import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7aeb88e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "about",
  class: "mb-16"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Sobre Mí", -1))
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-[auto_1fr] gap-10 items-start" }
const _hoisted_4 = { class: "flex flex-col items-center md:items-start gap-4" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "space-y-4" }
const _hoisted_8 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-8 pt-6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-mono-label text-xs uppercase tracking-[0.14em] text-subtle mb-3" }, " Educación ", -1))
const _hoisted_10 = { class: "space-y-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-mono-label text-xs uppercase tracking-[0.14em] text-subtle mb-3" }, " Idiomas ", -1))
const _hoisted_12 = { class: "space-y-3" }
const _hoisted_13 = { class: "text-subtle" }

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SobreMi',
  setup(__props) {

const fotoPerfil = require('@/assets/foto.jpg');

const biografia = ref([
  'Soy Desarrollador Backend Java con experiencia en Spring Boot, APIs REST e integraciones empresariales dentro del sector bancario. Actualmente en TechyWe, doy mantenimiento y desarrollo funcionalidades para sistemas en producción de Banco Hipotecario (BH) y el sistema de facturación electrónica RUBRIDOC, trabajando con Maven, AWS S3 y GitHub Actions CI/CD.',
  'Tengo conocimientos en servicios SOAP, mensajería JMS/MQ y bases de datos relacionales (PostgreSQL, MySQL, Oracle). Trabajo profesionalmente con Java 8/11 y practico Java 17. Soy autodidacta, con interés en seguir creciendo hacia arquitecturas cloud y DevOps, y complemento mi flujo de trabajo con herramientas de IA como Claude Code para revisión y validación de código.',
]);

const educacion = ref([
  'Universidad de El Salvador — Ingeniería de Sistemas Computacionales',
  'KODIGO | Creative Technology Academy — Bootcamp Full Stack Jr.',
  'Oracle Next Education | Alura Latam — Especialización Java Backend',
]);

const idiomas = ref([
  { nombre: 'Español', nivel: 'Nativo' },
  { nombre: 'Inglés', nivel: 'Intermedio' },
]);

const redesSociales = ref([
  {
    nombre: 'LinkedIn',
    url: 'https://linkedin.com/in/juan-alonso-rodriguez-rivera-0b88291aa',
    icono: 'fab fa-linkedin-in',
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          src: _unref(fotoPerfil),
          alt: "Juan Alonso Rodríguez",
          class: "w-44 h-44 object-cover rounded-sm border border-hairline grayscale hover:grayscale-0 transition-all duration-500"
        }, null, 8, _hoisted_5),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(redesSociales.value, (red) => {
          return (_openBlock(), _createElementBlock("a", {
            key: red.nombre,
            href: red.url,
            target: "_blank",
            rel: "noopener",
            class: "text-subtle hover:text-indigo2 transition-colors text-sm"
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(red.icono + ' mr-2')
            }, null, 2),
            _createTextVNode(_toDisplayString(red.nombre), 1)
          ], 8, _hoisted_6))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(biografia.value, (parrafo, index) => {
          return (_openBlock(), _createElementBlock("p", {
            key: index,
            class: "text-subtle leading-relaxed max-w-[65ch]"
          }, _toDisplayString(parrafo), 1))
        }), 128)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, [
            _hoisted_9,
            _createElementVNode("ul", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(educacion.value, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "text-sm text-ink leading-snug border-l-2 border-hairline pl-3"
                }, _toDisplayString(item), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_11,
            _createElementVNode("ul", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(idiomas.value, (idioma, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "text-sm text-ink border-l-2 border-hairline pl-3"
                }, [
                  _createTextVNode(_toDisplayString(idioma.nombre) + " ", 1),
                  _createElementVNode("span", _hoisted_13, "— " + _toDisplayString(idioma.nivel), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})